/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./announcements.vue?vue&type=template&id=e7519d08&scoped=true&"
import script from "./announcements.vue?vue&type=script&lang=js&"
export * from "./announcements.vue?vue&type=script&lang=js&"
import style0 from "./announcements.vue?vue&type=style&index=0&id=e7519d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7519d08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBanner,VBtn,VIcon})
